export default __webpack_public_path__ + "static/media/10.fed36e5b.jpg";